import { Component, OnInit, Input } from '@angular/core';
// import { FormConfig } from '@ptl/forms';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { FormPageComponentClass } from '@ptl/forms';
import { FormConfig } from '@ptl/forms';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { setApplicationQualificationService } from '../../../../shared/reducers/applicationQualification.reducer';
import { PagePreauthorizationService } from '../page-preauthorization/page-preauthorization.service';


@FormComponentLookup('page-preauth-and-eligibility')
@Component({
    selector: 'app-page-preauth-and-eligibility',
    templateUrl: './page-preauth-and-eligibility.component.html',
    styleUrls: ['./page-preauth-and-eligibility.component.scss'],
    standalone: false
})

export class PagePreauthAndEligibilityComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  isLoading = false;

  constructor(
    protected ngRedux: NgRedux<StateStructure>,
    private preauthService: PagePreauthorizationService
  ) {
    super();
  }

  ngOnInit() {
    this.initPageConfig();

    if (this.formConfig.form.customConfigs?.ageCheckConfig) {
      this.preauthService.configureAgeCheck(
        this.formConfig.form.customConfigs?.ageCheckConfig,
        this.subscriptionGroup,
        this.pageFormGroups,
        this.formStreamTrigger
      );
    }
  }

  submitHook(formConfig): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.isLoading = true;
      const eligibilityFlowResponse = await this.preauthService.getApplicationQualification();
      this.ngRedux.dispatch(setApplicationQualificationService(eligibilityFlowResponse));
      this.preauthService.saveMedigapDataToState(this.formConfig, {flow: eligibilityFlowResponse.payload.application});
      this.isLoading = false;
      resolve(true);
    });
  }
}
